import { scope } from '../../hoc/withPermissions'
import { usePermission } from '../usePermission/usePermission'
import { useQuery } from '../useQuery/useQuery'

import { getGamificationRulesSummary } from '@percent/workplace-giving/api/gamification/getGamificationRulesSummary/getGamificationRulesSummary'

export function useHasWalletRewards() {
  const has = usePermission()
  const hasGamificationScope = has(scope('gamification'))

  const { data } = useQuery(['getGamificationRulesSummary'], getGamificationRulesSummary, {
    staleTime: 1000 * 60,
    enabled: hasGamificationScope
  })

  return hasGamificationScope && data === true
}
